import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowLeft, FiCamera } from "react-icons/fi";
import appApi from "../../assets/utils/AppApi";
import { baseURL } from "../../assets/constants/baseUrl";
import HeroCarousel from "./HeroCarousel";
import styles from "./Styles/LatestGallery.module.css";

export default function LatestGallery() {
  const [events, setEvents] = useState([]);
  const [status, setStatus] = useState("loading");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setStatus("loading");
    // The homepage feed returns the latest three galleries.
    appApi.get("/gallery/latest", { signal: controller.signal })
      .then(({ data }) => {
        if (controller.signal.aborted) return;
        if (!Array.isArray(data)) throw new Error("Invalid gallery response");
        setEvents(data.slice(0, 3).map(event => ({ ...event, id: event._id, title: event.name })));
        setStatus("ready");
      }).catch(() => { if (!controller.signal.aborted) setStatus("error"); });
    return () => controller.abort();
  }, [attempt]);
  return (
    <section className={styles.section} aria-labelledby="latest-gallery-title" aria-busy={status === "loading"}>
      <div className={styles.heading}>
        <div><span className={styles.eyebrow}>قاب‌هایی از همراهی</span><h2 id="latest-gallery-title">آخرین گزارش تصویری</h2></div>
        <Link to="/gallery">همه گزارش‌های تصویری <FiArrowLeft aria-hidden="true" /></Link>
      </div>
      {status === "loading" ? <div className={styles.message} role="status">در حال دریافت آخرین گزارش تصویری…</div>
        : status === "error" ? <div className={styles.message} role="status"><p>دریافت گزارش تصویری ممکن نشد.</p><button type="button" onClick={() => setAttempt((value) => value + 1)}>تلاش دوباره</button></div>
        : !events.length ? <div className={styles.message}>گزارش‌های تصویری تازه به‌زودی اینجا نمایش داده می‌شوند.</div>
        : <HeroCarousel slides={events} label="آخرین گزارش تصویری" className={styles.carousel} renderSlide={(event, active) => {
  const photos = (event?.files || []).filter((file) => file.name &&
    (/^image\//i.test(file.mimetype || "") || /\.(jpe?g|png|webp|gif|avif)$/i.test(file.name)));
  const date = event?.eventDate ? new Date(event.eventDate) : null;
    return <article className={styles.card}>
          <div className={styles.copy}>
            <span className={styles.eyebrow}><FiCamera aria-hidden="true" /> تازه‌ترین قاب از خانواده ما</span>
            <h3>{event.name}</h3>
            {date && !Number.isNaN(date.getTime()) && <time dateTime={date.toISOString()}>{date.toLocaleDateString("fa-IR", { year: "numeric", month: "long", day: "numeric" })}</time>}
            {event.description && <p>{event.description}</p>}
            <Link tabIndex={active ? undefined : -1} className={styles.action} to="/gallery">مشاهده گزارش تصویری <FiArrowLeft aria-hidden="true" /></Link>
          </div>
          <Link tabIndex={active ? undefined : -1} to="/gallery" className={`${styles.photos} ${photos.length < 3 ? styles.fewerPhotos : ""}`} aria-label={`مشاهده گزارش تصویری ${event.name}`}>
            {photos.length ? photos.slice(0, 3).map((photo, index) => <img key={photo._id || photo.name}
              src={`${baseURL.replace(/\/$/, "")}/file/get/${encodeURIComponent(photo.name)}`}
              alt={`${event.name}، تصویر ${(index + 1).toLocaleString("fa-IR")}`} loading="lazy"
              onError={(error) => { error.currentTarget.style.visibility = "hidden"; }} />)
              : <span className={styles.placeholder}><FiCamera aria-hidden="true" />مشاهده رسانه‌های این رویداد</span>}
            {photos.length > 0 && <span className={styles.photoCount}><FiCamera aria-hidden="true" />{photos.length.toLocaleString("fa-IR")} تصویر</span>}
          </Link>
        </article>; }} />}
    </section>
  );
}
